import { Store } from 'src/store/index';

const getUsedClipArts = (store: Store) => store.addon.usedClipArts.clipArts;
export default getUsedClipArts;
